var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.locales),function(loc){return _c('div',{key:loc},[(_vm.value)?_c('TextField',{attrs:{"def":_vm.def,"title":_vm.def.name + ' - ' + loc,"disabled":_vm.disabled},model:{value:(_vm.value[loc]),callback:function ($$v) {_vm.$set(_vm.value, loc, $$v)},expression:"value[loc]"}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }